package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_04_19_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-04-19")
@Composable
public fun Log_2024_04_19(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Marilith Rampage",
        ogTitle = "Marilith Rampage",
        date = LocalDate(2_024, 4, 19),
        ogDescription = "Two Marilith demons attack the party in Zedj, and Tuesday transforms his allies into T-Rexes to crush them.",
        ogImage = "ai/2024-04-19.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-51", dateString = "Newgrowth 51")
        Log_2024_04_19_Day_1()
    }
}
